import { id } from '@/i18n/id';

/**
 * Blocking screen shown when this tablet's config.json is missing or invalid.
 * Rendered instead of the router — the kiosk must not accept orders it cannot
 * attribute to a kiosk, since the backend routes the queue ticket to a printer
 * based on that identity.
 *
 * `detail` is the loader's message (which URL failed, and why). It is technical
 * and English-ish on purpose: it is for the staff member or technician fixing
 * the deployment, not for a customer.
 */
export function KioskConfigError({ detail }: { detail: string }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 bg-cream px-10 text-center">
      <h1 className="text-3xl font-bold uppercase tracking-wide text-cocoa">
        {id.kioskConfig.errorTitle}
      </h1>
      <p className="text-lg text-ink-muted">{id.kioskConfig.errorBody}</p>
      <code className="mt-4 max-w-full break-words text-xs text-ink-faint">{detail}</code>
    </div>
  );
}
